import { useEffect, useState } from "react";
import Select from 'react-select'
import { AdminService } from "../../../../../services/admin.service";
import toast from "react-hot-toast";

const BioData = ({profile, setProfile}:any) => {

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(Array(6).fill(false));


    
    const saveProfile = async (e:any) => {
        e.preventDefault()
        if(profile.instructor_profile.languages.length==0){
            toast.error("Languages can't be empty");
            return;
        }
        if(!profile.instructor_profile.bio || (profile.instructor_profile.bio).toString().length < 50){
            toast.error("Instructor bio should be atleast 50 length");
            return;
        }
        if(!profile.instructor_profile.numYearExperience || profile.instructor_profile.numYearExperience < 0){
            toast.error("Number of experience cannot be smaller than 0");
            return;
        }
        try{
            setLoading(true);
            const profile1 = {
                bio: profile.instructor_profile.bio,
                languages: profile.instructor_profile.languages,
                numYearExperience: profile.instructor_profile.numYearExperience
            }
            await AdminService.updateInstructorProfileByUserId(profile.instructor_profile._id, profile1).then((res)=>{
                if(res.status==200){
                    toast.success("Profile updated");
                }
            })
            .catch((err)=>{
                console.log(err);
                toast.error("Someting went wrong");
            })

            setLoading(false);

        } catch(err){
            console.log(err)
            setLoading(false)
            throw err;
        }
    }
    
    return (
        <form className = "">
            <div className="row justify-content-between align-items-center ">
                <div className="col">
                    <div className="row align-items-center">
                        <div className="col-auto pr-5">
                            <div className="avatar avatar-xxl">
                            <img className="avatar-img rounded-circle"  src={profile.avatar} alt="..." />
                            </div>
                        </div>
                        <div className="col ml-n2">
                            <div className = 'row mt-5'>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Email</label>
                                        <div className = 'mb-3'>{profile.email} </div>
                                    </div>
                                </div>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Phone Number</label>
                                        <div className = 'mb-3'>{profile.phone} </div>
                                    </div>
                                </div>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Gender</label>
                                        <div className = 'mb-3'>{profile.instructor_profile.gender} </div>
                                    </div>
                                </div>
                            </div>
                            <div className = 'row '>
                                <div className = 'col-4'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Instrument to teach</label>
                                        <div className = 'mb-3'>{profile.instrumentToTeach} </div>
                                    </div>
                                </div>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Teaches Kids</label>
                                        <div className = 'mb-3'>{profile.teachesChildren? 'Yes' : 'No'} </div>
                                    </div>
                                </div>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Mapping</label><br/>
                                        {profile.isBackgroundChecked && <span className = 'badge badge-primary mr-2'>Background Approved</span>}
                                        {profile.isStarTeacher && <span className = 'badge badge-primary'>Star Teacher</span>}
                                        {profile.isBulkDiscount && <span className = 'badge badge-primary'>Bulk Discount Available</span>}
                                    </div>
                                </div>
                            </div>
                            <div className = 'row '>
                                <div className = 'col-4'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Experience (Num years)</label>
                                        <input 
                                            className = {(profile.instructor_profile.numYearExperience && profile.instructor_profile.numYearExperience<0)  ? 'form-control is-invalid' : 'form-control'}
                                            value = {profile.instructor_profile.numYearExperience} 
                                            placeholder = "How many years of experience do you have?"
                                            onChange = {e => {setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, numYearExperience: e.target.value}}))}}
                                            type = "number"
                                        />
                                    </div>
                                </div>
                                <div className = 'col'>
                                    <div className = 'form-group '>
                                        <label className= 'bold mb-1'>Languages</label>
                                        <Select 
                                            options = {langOptions} 
                                            isMulti
                                            value = {langOptions.filter(item => profile.instructor_profile.languages ? profile.instructor_profile.languages.includes(item.value) : false)}
                                            onChange = {e => {setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, languages: e.map((item:any) => item.value)}}))}}
                                        />
                                        {(profile.instructor_profile.languages && profile.instructor_profile.languages.length<=0) && <div className = 'invalid-feedback d-block'>Please select at least one language</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div> 

           
           
            <div className = 'form-group mt-3'>
                <label className= 'bold mb-1'>Instructor bio</label>
                <textarea 
                    className = {(!profile.instructor_profile.bio || (profile.instructor_profile.bio).toString().length < 50)  ? 'form-control is-invalid' : 'form-control'}
                    style = {{minHeight: '200px'}} 
                    value = {profile.instructor_profile.bio} 
                    onChange = {e => {setProfile((prev:any) => ({...prev, instructor_profile: {...prev.instructor_profile, bio: e.target.value}}))}}
                /> 
                {(!profile.instructor_profile.bio || (profile.instructor_profile.bio).toString().length < 50) && <div className = 'invalid-feedback d-block'>{"Please write at least 50 characters"}</div>}
            </div>

            <button disabled = {loading} className = 'btn btn-block my-5 btn-primary px-6' onClick={(e)=>{saveProfile(e)}}>
                {loading && <span className = "spinner-border spinner-border-sm mr-2"></span>}
                Save
            </button>
        </form>
    )
}


export default BioData;


const langOptions = [
    {value: 'English', label: 'English'},
    {value: 'Hindi', label: 'Hindi'},
    {value: 'Bengali', label: 'Bengali'},
    {value: 'Marathi', label: 'Marathi'},
    {value: 'Telugu', label: 'Telugu'},
    {value: 'Tamil', label: 'Tamil'},
    {value: 'Punjabi', label: 'Punjabi'},
    {value: 'Gujarati', label: 'Gujarati'},
    {value: 'Kannada', label: 'Kannada'},
    {value: 'Urdu', label: 'Urdu'},
    {value: 'Odia', label: 'Odia'},
    {value: 'Malayalam', label: 'Malayalam'},
]